import { createFileRoute } from "@tanstack/react-router";
import { SideLetters } from "@/components/SideLetters";

function RouteComponent() {
  return <SideLetters />;
}

export const Route = createFileRoute("/_authenticated/side-letters/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
